import { TYPES } from "./types";
import { tkt1ScanPersonService } from "../services"; 

export const getTKT1ScanPersons = (query) => async (dispatch) => {
  try {
    const result = await tkt1ScanPersonService.getScanPersons(query);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_SCAN_PERSONS_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_SCAN_PERSONS_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const getTKT1ScanPersonByID = (id) => async (dispatch) => {
  try {
    const result = await tkt1ScanPersonService.getScanPersonByID(id);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_SCAN_PERSON_BY_ID_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_SCAN_PERSON_BY_ID_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const getTKT1ScanPersonByMID = (mid) => async (dispatch) => {
  try {
    const result = await tkt1ScanPersonService.getScanPersonByMID(mid);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_SCAN_PERSON_BY_MID_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_SCAN_PERSON_BY_MID_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const searchTKT1ScanPersons = (query) => async (dispatch) => {
  try {
    const result = await tkt1ScanPersonService.searchScanPersons(query);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_SEARCH_TKT1_SCAN_PERSONS_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_SEARCH_TKT1_SCAN_PERSONS_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const createTKT1ScanPerson = (scanPersonData) => async (dispatch) => {
  try {
    const result = await tkt1ScanPersonService.createScanPerson(scanPersonData);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_CREATE_TKT1_SCAN_PERSON_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_CREATE_TKT1_SCAN_PERSON_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const updateTKT1ScanPerson = (id, scanPersonData) => async (dispatch) => {
  try {
    const result = await tkt1ScanPersonService.updateScanPerson(id, scanPersonData);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_UPDATE_TKT1_SCAN_PERSON_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_UPDATE_TKT1_SCAN_PERSON_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const deleteTKT1ScanPerson = (id) => async (dispatch) => {
  try {
    const result = await tkt1ScanPersonService.deleteScanPerson(id);
    
    if (result.data.success) {
      dispatch({
        type: TYPES.ACTION_DELETE_TKT1_SCAN_PERSON_SUCCESS,
        payload: {id},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_DELETE_TKT1_SCAN_PERSON_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const tkt1ScanPersonAction = {
  getTKT1ScanPersons,
  getTKT1ScanPersonByID,
  getTKT1ScanPersonByMID,
  searchTKT1ScanPersons,
  createTKT1ScanPerson,
  updateTKT1ScanPerson,
  deleteTKT1ScanPerson
};
